import React, { useEffect, useRef } from 'react';
import { useFormikContext } from 'formik';
import { SelectFieldGroup } from '../Common/Input/FormFields';
import type { ServiceRequestService } from '../../models';

type SpecialtyServicesProps = {
    disabled?: boolean;
}

export const SpecialtyServicesLookup: React.FC<SpecialtyServicesProps> = ({ disabled }) => {
  const { values, setFieldValue } = useFormikContext<ServiceRequestService>();

  // Derive available specialty service options from the selected category/categories.
  const specialtyServices = (values as any).specialtyServices;
  const specialtyServiceOptions: string[] = Array.isArray(specialtyServices)
    ? specialtyServices
    : specialtyServices
      ? [specialtyServices]
      : [];

  const hasCategorySelection = specialtyServiceOptions.length > 0;
  
  // Reset the selected service whenever the category/categories change to avoid inconsistent submissions.
  const previousCategoriesRef = useRef(specialtyServices);
  useEffect(() => {
    if (specialtyServices !== previousCategoriesRef.current) {
      setFieldValue('specialtyServices', '');
      previousCategoriesRef.current = specialtyServices;
    }
  }, [specialtyServices, setFieldValue]);

  return (
    <>
      <SelectFieldGroup
        name="specialtyServices"
        title="Service Description"
        options={specialtyServiceOptions}
        disabled={!hasCategorySelection || disabled}
      />
    </>
  );
};